import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=26ecd777&scoped=true&lang=pug&"
import script from "./notify.vue?vue&type=script&lang=ts&"
export * from "./notify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ecd777",
  null
  
)

export default component.exports